<template>
  <div class="payment">
    <button
      type="submit"
      name="submit"
      id="donate-widget-form-submit"
      class="ou-donation-btn btn-flex membsershipbtn"
      formnovalidate="formnovalidate"
    >
      <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        width="20px"
        height="30px"
        viewBox="0 0 1190.000000 1280.000000"
        preserveAspectRatio="xMidYMid meet"
      >
        <g
          transform="translate(0.000000,1280.000000) scale(0.100000,-0.100000)"
          fill="#fff"
          stroke="none"
        >
          <path
            d="M5610 11999 c-1096 -88 -1924 -626 -2375 -1544 -80 -162 -155 -347
        -155 -380 0 -8 -4 -15 -8 -15 -4 0 -8 -8 -9 -17 -1 -19 -6 -38 -16 -63 -17
        -47 -78 -287 -91 -360 -3 -19 -8 -46 -11 -59 -2 -14 -7 -47 -10 -74 -3 -28 -8
        -53 -10 -56 -8 -13 -24 -189 -28 -313 -1 -27 -5 -48 -10 -48 -4 0 -3 -9 3 -20
        8 -14 8 -20 0 -20 -7 0 -8 -6 -1 -19 6 -10 8 -21 5 -24 -3 -3 -5 -392 -4 -865
        l1 -860 -26 -20 c-14 -11 -69 -30 -123 -43 -159 -36 -266 -74 -364 -128 -109
        -60 -149 -91 -240 -183 -206 -208 -334 -560 -353 -968 -5 -99 -4 -3022 1
        -3125 8 -175 28 -319 46 -343 7 -8 7 -12 -1 -12 -7 0 -9 -5 -4 -13 4 -6 8 -16
        9 -22 1 -5 11 -34 23 -62 11 -29 17 -53 13 -53 -4 0 -2 -4 3 -8 10 -7 37 -61
        37 -72 0 -3 6 -12 14 -21 8 -9 12 -18 9 -21 -3 -3 6 -17 20 -32 13 -14 25 -29
        25 -31 0 -14 84 -117 122 -150 24 -21 34 -32 23 -24 -18 13 -19 13 -6 -3 7
        -10 17 -18 22 -18 5 0 17 -8 27 -17 39 -37 67 -57 121 -86 175 -94 267 -121
        521 -153 111 -13 461 -15 3121 -14 3106 0 3123 0 3314 39 221 45 397 134 531
        270 161 162 238 342 269 626 12 107 15 407 15 1696 0 862 -2 1573 -4 1580 -3
        8 -7 63 -10 122 -4 60 -8 112 -10 116 -3 4 -7 27 -10 51 -17 143 -76 342 -137
        463 -30 57 -107 176 -138 211 -62 69 -159 160 -174 164 -13 3 -37 30 -38 44 0
        7 -4 4 -8 -7 -8 -19 -8 -19 -15 3 -5 14 -13 21 -21 18 -8 -3 -19 2 -25 10 -7
        8 -19 14 -26 14 -8 0 -14 5 -14 10 0 6 -7 10 -15 10 -8 0 -15 5 -15 10 0 6 -9
        10 -20 10 -11 0 -20 5 -20 11 0 5 -4 7 -10 4 -5 -3 -10 -1 -10 5 0 6 -4 8 -10
        5 -5 -3 -10 -2 -10 4 0 5 -8 8 -17 6 -10 -1 -30 4 -45 11 -15 8 -31 13 -35 13
        -4 -1 -16 1 -25 4 -46 18 -54 20 -69 23 -9 2 -27 8 -40 13 -13 5 -27 8 -30 7
        -4 0 -17 8 -30 19 -14 13 -20 14 -15 5 4 -8 -4 -2 -18 13 l-26 28 0 847 c-1
        466 -3 883 -5 927 -7 117 -14 206 -19 240 -3 24 -26 169 -40 255 -21 125 -30
        170 -36 170 -4 0 -6 10 -5 23 1 12 -1 27 -5 32 -5 6 -11 24 -13 40 -9 46 -14
        68 -25 96 -6 15 -8 29 -6 32 3 3 -2 22 -10 42 -9 21 -16 47 -16 59 0 16 -2 18
        -9 7 -7 -10 -11 -1 -16 32 -4 26 -12 47 -17 47 -6 0 -8 9 -5 20 3 11 1 20 -4
        20 -5 0 -9 7 -9 15 0 8 -4 15 -10 15 -5 0 -6 7 -3 17 5 11 3 14 -6 8 -10 -6
        -11 -2 -6 15 5 17 4 21 -5 15 -8 -5 -11 -4 -6 3 7 11 -28 93 -96 227 -22 44
        -55 107 -71 140 -17 33 -34 62 -38 65 -3 3 -16 25 -29 49 -12 24 -26 49 -31
        55 -30 36 -84 113 -105 149 -13 23 -24 38 -24 34 0 -4 -6 -2 -14 5 -8 7 -12
        16 -9 20 2 4 -7 19 -21 33 -15 14 -26 31 -26 37 0 6 -3 8 -7 5 -3 -4 -13 2
        -20 13 -8 11 -19 18 -24 15 -5 -4 -9 2 -9 12 0 11 -20 39 -45 63 -24 24 -42
        47 -39 52 3 4 -4 8 -15 8 -11 0 -22 9 -26 20 -3 11 -13 20 -21 20 -8 0 -14 7
        -14 15 0 8 -7 15 -16 15 -8 0 -12 5 -9 10 3 6 -1 10 -9 10 -9 0 -16 5 -16 11
        0 5 -3 8 -7 6 -5 -3 -14 1 -21 9 -7 8 -9 14 -5 14 4 1 -4 8 -19 16 -16 8 -28
        19 -28 24 0 6 -7 10 -15 10 -8 0 -15 5 -15 10 0 6 -5 10 -10 10 -6 0 -21 11
        -34 25 -13 14 -26 25 -30 25 -7 0 -67 41 -76 51 -3 3 -19 13 -37 22 -17 9 -37
        22 -45 29 -18 17 -59 42 -143 85 -38 19 -73 40 -76 45 -3 5 -9 9 -12 9 -4 0
        -26 8 -49 18 -374 158 -665 229 -1072 261 -150 12 -504 11 -656 -1z m475
        -1214 c103 -10 140 -15 240 -31 90 -15 283 -67 314 -85 17 -9 74 -31 79 -30
        10 4 273 -148 292 -170 3 -3 23 -18 44 -35 22 -16 49 -38 60 -49 12 -11 35
        -31 51 -43 17 -13 23 -21 15 -17 -8 4 -1 -6 16 -22 27 -24 98 -107 157 -184
        10 -13 27 -40 38 -59 11 -19 28 -48 39 -65 19 -30 73 -126 75 -135 1 -3 10
        -23 20 -45 10 -22 18 -43 17 -47 -1 -5 2 -8 6 -8 5 0 9 -6 10 -12 2 -29 29
        -88 37 -81 4 5 5 3 1 -4 -4 -7 7 -50 23 -97 16 -46 27 -87 24 -90 -3 -3 0 -12
        7 -21 7 -9 10 -18 7 -22 -4 -3 -2 -12 4 -20 9 -10 8 -13 -2 -13 -9 -1 -8 -5 5
        -15 11 -8 15 -15 8 -15 -8 0 -9 -7 -1 -27 6 -16 12 -37 14 -48 8 -49 27 -203
        29 -230 0 -16 5 -33 11 -37 7 -5 6 -8 0 -8 -6 0 -11 -9 -11 -20 0 -11 4 -20 9
        -20 5 0 4 -6 -2 -14 -9 -11 -9 -15 1 -20 10 -5 10 -7 1 -12 -19 -8 -16 -24 5
        -24 10 0 13 -3 6 -8 -16 -10 -18 -222 -3 -222 8 0 9 -4 0 -13 -8 -10 -12 -215
        -13 -707 l-3 -694 -34 -20 c-34 -20 -56 -20 -1717 -24 -1216 -3 -1683 -1
        -1688 7 -4 6 -22 11 -40 11 -69 0 -65 -59 -66 905 -1 479 -1 872 0 875 1 3 3
        32 5 65 4 65 10 117 26 210 6 33 12 71 13 85 2 14 6 32 10 41 4 9 8 27 10 41
        1 13 5 28 8 33 3 6 9 28 13 50 8 42 47 159 71 212 8 17 14 34 14 39 0 33 188
        356 247 424 36 42 197 200 239 235 110 93 398 240 507 259 7 1 28 7 47 14 58
        19 273 52 382 58 57 4 104 7 105 8 4 3 156 -3 218 -9z"
          />
        </g>
      </svg>
      <span v-if="processing">
        <div class="lds-ellipsis">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </span>
      <span v-else class="flex">

      <span style="display: flex;" v-if="amountFirst">
        Donate
        <span v-if="form.amount && showAmount" class="amount">{{ form.currency === 'ILS' ? '₪' : '$' }}{{ amount }}</span>
        <span v-if="showAmount && !form.amount" class="amount amount--sm"> $0</span>
        Now
      </span>
      <span v-else>
        {{ btnText }}
        <span v-if="form.amount && showAmount" class="amount">{{ form.currency === 'ILS' ? '₪' : '$' }}{{ amount }}</span>
        <span v-if="showAmount && !form.amount" class="amount"> {{form.currency == 'ILS' ? '₪' : '$'}}0</span>
      </span>
        
      </span>
    </button>
  </div>
</template>
<script setup lang="ts">
import { computed, ref, onMounted, onUnmounted } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

withDefaults(defineProps<{
  showAmount?: boolean
  btnText?: string
  amountFirst?: boolean
}>(), {
  btnText: "Process",
  amountFirst: false
})

const paymentForm = usePaymentForm();
const { submitting, actorRef } = paymentForm;

// Create a reactive ref that updates when the actor state changes
const formAmount = ref<string | null>(actorRef.getSnapshot().context.form.amount);
const formGateway = ref<string | null>(actorRef.getSnapshot().context.form.gateway);
const formHandleProcessing = ref<boolean>(actorRef.getSnapshot().context.form.handleProcessing);
const formPeriodMonths = ref<string | null>(actorRef.getSnapshot().context.form.periodMonths);
const formDayOfMonth = ref<string | null>(actorRef.getSnapshot().context.form.dayOfMonth);
const formCurrency = ref<string>(actorRef.getSnapshot().context.form.currency);

// Subscribe to actor changes
let subscription: any;
onMounted(() => {
  subscription = actorRef.subscribe((state) => {
    formAmount.value = state.context.form.amount;
    formGateway.value = state.context.form.gateway;
    formHandleProcessing.value = state.context.form.handleProcessing;
    formPeriodMonths.value = state.context.form.periodMonths;
    formDayOfMonth.value = state.context.form.dayOfMonth;
    formCurrency.value = state.context.form.currency;
  });
});

onUnmounted(() => {
  subscription?.unsubscribe();
});

// Create a form object for template compatibility
const form = computed(() => ({
  amount: formAmount.value,
  gateway: formGateway.value,
  handleProcessing: formHandleProcessing.value,
  periodMonths: formPeriodMonths.value,
  dayOfMonth: formDayOfMonth.value,
  currency: formCurrency.value
}));

const amount = computed(() => {
  //@ts-ignore
  let calculatedAmount = ['wire', 'check'].includes(formGateway.value)
  ? +formAmount.value!
  : formHandleProcessing.value
    ? Math.round((+formAmount.value! + +formAmount.value! * 0.025) * 100) / 100
    : +formAmount.value!;

  if (formPeriodMonths.value && formDayOfMonth.value) {
  calculatedAmount *= +formPeriodMonths.value;
  }

  return calculatedAmount;
});

const processing = submitting
</script>
<style lang="scss" scoped>
.payment {
  display: flex;
  font-size: 14px;
  align-items: center;
  margin-bottom: 10px;
}
.amount {
  margin: 0 5px;
}
.flex {
  display: flex;
}
.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 20px;
}
.lds-ellipsis div {
  position: absolute;
  top: 7px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #fff;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
  left: 8px;
  animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 8px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 32px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 56px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(24px, 0);
  }
}
</style>
